import { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import { Box, makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import MI from "./MI";
import HomeHeaderMenu from "../../../../Home/HomeHeaderMenu";
import OrgDashboard from "../../../../Auth/Dashboard";
import AdminDashboard from "../Dashboard";
import AdminHome from "../../../../../Components/HeaderMenu";
import MIContextProvider from "./MIContext";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  dashboardToggle: {
    top: "64px",
    position: "sticky",
    zIndex: "101",
    backgroundColor: "#fff",
    margin: "0px",
    padding: "8px 64px 0px 64px",
  },
}));
const IOSSwitch = withStyles((theme) => ({
  root1: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#52d869",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#52d869",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 22,
  },
  track: {
    height: 24,
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: theme.palette.grey[50],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root1,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function SimpleAction() {
  const classes = useStyles();
  const [viewType, setViewType] = useState("mi");
   const globaluserData = useSelector((state) => state.commonReducer);
   const role = globaluserData?.role;
   
  const handleChange = (event) => {
    setViewType(event.target.checked ? "dashboard" : "mi");
  };
  let Dashboard = OrgDashboard;
  if (role === "admin") {
    Dashboard = AdminDashboard;
  }

  return (
    <>
      {role === "partner" || role === "employee" ? (
        <HomeHeaderMenu />
      ) : (
        <AdminHome />
      )}

      <Box my={1} mx={8} className={classes.dashboardToggle}>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={8}>
            {viewType === "mi" ? (
              <Typography
                variant="h1"
                color="primary"
                style={{ fontWeight: "800" }}
              >
                Management Information{" "}
              </Typography>
            ) : (
              <Typography
                variant="h1"
                color="primary"
                style={{ fontWeight: "800" }}
              >
                Dashboard{" "}
              </Typography>
            )}
          </Grid>
          <Grid item xs={4}>
            <Box textAlign="right">
              <Typography
                variant="h2"
                component="span"
                style={{ color: "#077f83", fontWeight: "bold" }}
              >
                MI view
              </Typography>
              <IOSSwitch name="checkedC" onChange={handleChange} />
              <Typography
                variant="h2"
                component="span"
                style={{ color: "#077f83", fontWeight: "bold" }}
              >
                Dashboard
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <div className={classes.cmp}>
        {viewType === "mi" ? (
          <MIContextProvider>
            <MI />
          </MIContextProvider>
        ) : (
          <Dashboard isManageInfo={role === "admin"} />
        )}
      </div>
    </>
  );
}
